export default "<div class=\"h-100\">\r\n    <img src=\"/SiteAssets/ngapp/freejna/assets/img/busy-indicator-loader.gif\" alt=\"header-icon\">\r\n</div>\r\n"